import { createSelector, createSlice } from "@reduxjs/toolkit"
import { ContextMenu, ContextMenuKey } from "./contextMenu"
import { RootState } from "integrations/redux"
import { setSnapshotOpen } from "plugins/PDFv2/PDFSlice"

type PopupsState = {
    activeContextMenu: ContextMenu<ContextMenuKey>
    inspectorPanelState: "active" | "inactive"
    openLiveVideoFlightIds: string[]
}

const initialState: PopupsState = {
    activeContextMenu: undefined,
    inspectorPanelState: "active",
    openLiveVideoFlightIds: [],
}

export const popupsSliceName = "popups" as const
export const {
    reducer: PopupsReducer,
    actions: { setActiveContextMenu, setInspectorPanelState },
} = createSlice({
    name: popupsSliceName,
    initialState,
    reducers: {
        setActiveContextMenu: (state, action: { payload: PopupsState["activeContextMenu"] }) => {
            state.activeContextMenu = action.payload
        },
        setInspectorPanelState: (
            state,
            action: { payload: PopupsState["inspectorPanelState"] }
        ) => {
            state.inspectorPanelState = action.payload
        },
    },
    extraReducers: (b) =>
        b.addCase(setSnapshotOpen, (state, { payload }) => {
            state.inspectorPanelState = payload ? "inactive" : "active"
        }),
})

export const selectInspectorPanelState = createSelector(
    [(s: RootState) => s[popupsSliceName]],
    (s) => s.inspectorPanelState
)
